import React from 'react'
import Section from './Section'
import Section1 from './Section1'
import Navbar7 from '../../layout/Navbar7'

const Index10 = () => {
  return (
    <React.Fragment>
        <Navbar7 />
        <Section />
        <Section1 />
    </React.Fragment>
  )
}

export default Index10